import React from "react";

const Exachanges = () => {
  return <div>Exchanges</div>;
};

export default Exachanges;
